import {
  POST_NEW_INSTITUTION,
  POST_SAVE_SEARCH,
  GET_INSTITUTION_DETAILS,
  GET_SAVED_SEARCHES,
  DELETE_SEARCH,
  GET_INSTITUTION_PUBLIC_DETAILS,
  DELETE_INSTITUTION,
  POST_BAN_KEYWORD,
  DELETE_UNBAN_KEYWORD,
  GET_BANNED_KEYWORDS
} from '@/services/institutions'

const postBanKeyword = (context, data) => {
  return POST_BAN_KEYWORD(data)
}

const postSaveSearch = (context, data) => {
  return POST_SAVE_SEARCH(data)
}

const getBannedKeywords = () => {
  return GET_BANNED_KEYWORDS()
}

const getSavedSearches = () => {
  return GET_SAVED_SEARCHES()
}

const deleteUnbanKeyword = (context, data) => {
  return DELETE_UNBAN_KEYWORD(data)
}

const postNewInstitution = (context, data) => {
  return POST_NEW_INSTITUTION(data)
}

const getInstitutionDetails = (context, institutionId) => {
  return GET_INSTITUTION_DETAILS(institutionId)
}

const getInstitutionPublicDetails = (context, institutionId) => {
  return GET_INSTITUTION_PUBLIC_DETAILS(institutionId)
}

const deleteInstitution = (context, institutionId) => {
  return DELETE_INSTITUTION(institutionId)
}

const deleteSearch = (context, searchId) => {
  return DELETE_SEARCH(searchId)
}

export default {
  postNewInstitution,
  postSaveSearch,
  getInstitutionDetails,
  getSavedSearches,
  getInstitutionPublicDetails,
  deleteInstitution,
  deleteSearch,
  postBanKeyword,
  getBannedKeywords,
  deleteUnbanKeyword
}
